import { Heart, ShieldCheck, Smile, PartyPopper, Award } from "lucide-react";

const reasons = [
  {
    icon: Heart,
    title: "We Actually LOVE Kids",
    desc: "Little ones aren't a job to us — they're our favorite people.",
    bg: "bg-[#FF6B9E]",
  },
  {
    icon: Award,
    title: "Lots of Experience",
    desc: "Between the six of us, we've babysat tons of little ones already!",
    bg: "bg-[#FF8E72]",
  },
  {
    icon: ShieldCheck,
    title: "Buddy System",
    desc: "Two sitters come to every job, plus our 17-year-old manager stays close by.",
    bg: "bg-[#4DB8FF]",
  },
  {
    icon: PartyPopper,
    title: "Endless Energy",
    desc: "We can keep up. Tag, dance party, fort building — bring it on.",
    bg: "bg-[#38E5B6]",
  },
  {
    icon: Smile,
    title: "Super Kind",
    desc: "Patience, kindness and silly jokes are kinda our thing.",
    bg: "bg-[#FFD166]",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 px-4 bg-[#E6FFF7]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="font-hand text-3xl text-[#FF8E72]">~ why pick us? ~</span>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl text-gray-900 mt-2">
            Because we're <span className="text-[#4DB8FF]">awesome</span> at this!
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`why-card-${i}`}
                className="bg-white border-4 border-gray-900 rounded-3xl p-6 shadow-pop hover:-translate-y-2 transition-transform duration-300"
                style={{ transform: `rotate(${[-1.5, 1, -1, 1.5, -1][i]}deg)` }}
              >
                <div
                  className={`w-14 h-14 ${r.bg} border-2 border-gray-900 rounded-full flex items-center justify-center mb-4`}
                >
                  <Icon size={26} className="text-gray-900" strokeWidth={2.5} />
                </div>
                <h3 className="font-display text-xl text-gray-900 mb-2">{r.title}</h3>
                <p className="text-sm text-gray-700 font-semibold leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>

        {/* Marquee-like strip */}
        <div
          data-testid="why-strip"
          className="mt-16 bg-gray-900 text-[#FFD166] border-4 border-gray-900 rounded-full py-4 px-6 overflow-hidden"
        >
          <div className="flex items-center justify-center gap-6 font-display text-base sm:text-lg whitespace-nowrap flex-wrap">
            <span>★ FUN</span>
            <span className="text-[#FF6B9E]">★ KIND</span>
            <span className="text-[#38E5B6]">★ SAFE</span>
            <span className="text-[#4DB8FF]">★ SILLY</span>
            <span className="text-[#FF8E72]">★ CREATIVE</span>
            <span>★ SNACKS</span>
            <span className="text-[#FF6B9E]">★ FUN</span>
          </div>
        </div>
      </div>
    </section>
  );
}
